import { useEffect, useMemo, useState } from 'react';
import useDebouncedText from './useDebouncedText';
import { getYear } from 'Util/DateUtils';

const useFilter = ({ fieldList }) => {
  const [searchText, setSearchText] = useState('');
  const [yearList, setYearList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const { getFilteredList: getFilteredListBySearchText } = useDebouncedText({ searchText, fieldList });

  useEffect(() => {
    const years = fieldList.map(field => getYear(field.dateConstructStart)).filter(year => year !== '');
    setYearList([...new Set(years)].sort((a, b) => b - a));
  }, [fieldList]);

  const updateText = value => {
    setSearchText(value);
  };

  const updateYear = value => {
    setSelectedYear(value);
  };

  const getFilteredList = useMemo(() => {
    const removeFirstField = getFilteredListBySearchText.filter(field => !field.isFirstField);
    if (!selectedYear) {
      return removeFirstField;
    }
    return removeFirstField.filter(field => getYear(field.dateConstructStart) === selectedYear);
  }, [getFilteredListBySearchText, selectedYear]);

  return { searchText, updateText, getFilteredList, yearList, selectedYear, updateYear };
};

export default useFilter;
